import { Reveal, Chapter } from "./Reveal";

const STEPS = [
  { n: "01", title: "Quarry Selection", desc: "Responsible extraction, careful selection at the source.", img: "/catalog/process-quarry.jpg", alt: "Worker extracting stone at a Kota quarry" },
  { n: "02", title: "Block Cutting", desc: "Quarry blocks precisely cut into manageable slabs.", img: "/catalog/process-cutting.jpg", alt: "Circular saw cutting a raw Kota stone block" },
  { n: "03", title: "Surface Finishing", desc: "Automatic polishing line — one stone, many finishes.", img: "/catalog/process-polishing.jpg", alt: "Automatic polishing line finishing Kota stone slabs" },
  { n: "04", title: "Inspection & Packing", desc: "Checked, corner-protected, ready for transit.", img: "/catalog/process-packing.jpg", alt: "Workers inspecting and packing finished stone" },
];

const Process = () => (
  <section id="process" className="relative bg-coal border-t border-bone/10 px-6 md:px-12 lg:px-20 py-28 md:py-36" data-testid="process-section">
    <div className="flex flex-col gap-6 mb-16">
      <Reveal>
        <Chapter index="02" title="The Process" testid="process-chapter" />
      </Reveal>
      <Reveal delay={0.1} className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <h2 className="text-4xl sm:text-5xl font-heading font-bold tracking-tight leading-[1.05] max-w-2xl" data-testid="process-heading">
          Raw stone to{" "}
          <span className="font-editorial italic font-medium text-copper">ready-to-use.</span>
        </h2>
        <p className="max-w-sm text-sm md:text-base font-light text-bone/60 leading-relaxed">
          Precise processing, consistent quality, reliable supply — every slab
          passes through five controlled stages before it leaves our units.
        </p>
      </Reveal>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
      {STEPS.map((s, i) => (
        <Reveal key={s.n} delay={i * 0.08}>
          <figure className="group relative overflow-hidden bg-stone h-[300px] md:h-[380px]" data-testid={`process-step-${s.n}`}>
            <img
              src={s.img}
              alt={s.alt}
              loading="lazy"
              className="h-full w-full object-cover grayscale-[35%] transition-[transform,filter] duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0"
            />
            <span className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/25 to-transparent" />
            <figcaption className="absolute inset-x-0 bottom-0 p-5">
              <span className="block font-editorial italic text-lg text-copper">{s.n}</span>
              <span className="mt-1 block font-heading font-extrabold uppercase tracking-tight text-lg leading-tight">{s.title}</span>
              <span className="mt-1.5 block text-xs font-light text-bone/60 leading-snug">{s.desc}</span>
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>

    <Reveal delay={0.15} className="mt-6">
      <p className="text-xs tracking-[0.25em] uppercase font-heading text-bone/40 text-right" data-testid="process-note">
        Every slab calibrated to uniform thickness & precision-cut to 90° — ready for installation
      </p>
    </Reveal>
  </section>
);

export default Process;
